import { useContext } from 'react';
import { ToastContext } from '@/presentation/context/toast-context';

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return ctx;
}
